import { ModuleWithProviders, NgModule } from '@angular/core';

import { DispatcherInstrumentationService } from './dispatcher-instrumentation.service';
import { InstrumentClickDirective } from './instrument-click.directive';
import { InstrumentElementInViewportDirective } from './instrument-element-in-viewport.directive';
import { InstrumentPageViewDirective } from './instrument-page-view.directive';
import { InstrumentationService } from './instrumentation.service';

@NgModule({
    declarations: [
        InstrumentClickDirective,
        InstrumentElementInViewportDirective,
        InstrumentPageViewDirective
    ],
    exports: [
        InstrumentClickDirective,
        InstrumentElementInViewportDirective,
        InstrumentPageViewDirective
    ]
})
export class InstrumentationModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: InstrumentationModule,
            providers: [
                {
                    provide: InstrumentationService,
                    useClass: DispatcherInstrumentationService
                }
            ]
        };
    }
}
